var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAtmIcnMail = function SvgAtmIcnMail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.25,
    d: "M18.65 5c1.236 0 2.25.986 2.25 2.2v10.5c0 1.214-1.014 2.2-2.25 2.2H4.25C3.014 19.9 2 18.914 2 17.7V7.2C2 5.986 3.014 5 4.25 5h14.4zM20 8.05l-7.284 4.958c-.764.52-1.768.52-2.532 0h0L2.9 8.05V17.7c0 .711.606 1.3 1.35 1.3h14.4c.744 0 1.35-.589 1.35-1.3V8.05zM18.65 5.9H4.25c-.665 0-1.219.47-1.33 1.076l7.77 5.288c.459.312 1.061.312 1.52 0h0l7.77-5.289c-.112-.606-.666-1.075-1.33-1.075z",
    transform: "translate(-1 -4)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAtmIcnMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "atm-icn-mail.9ceda47abfeddf6ad80f62b36c9381e5.svg";